import React from 'react';
import './allCss/GameCard.css';

import {Link} from 'react-router-dom';




class GameCard extends React.Component {

        changeScroll = () => {
            window.scrollTo({
                top: 0,
                left: 0
              });
        }
    render () {

        if (!this.props.game) {
            return <div>Loading..</div>
        }
        return (
    
                <Link to={`/games/${this.props.game.id}`}  onClick={this.changeScroll} id="gameCard"  className="ui raised link card ">
                <div  className="image ">
                        <img className='' style={{height: '250px'}} alt='' src={this.props.game.url}/>
                </div>
                <div className="content">
    
                    <img id="tiny-image" className="left floated tiny ui image" alt='' src={this.props.game.gameIcon}/>
                        <div  ><h3 className="header-title">{this.props.game.title}</h3></div>
                    <p className="description">
                    {this.props.game.gameDescription}
                    </p>
                        <div className="view-more" >
                        View More +
                        </div>
                </div>
                <div className="extra content">
                    <i className="right floated html5 icon"></i>
                </div>
                
                </Link>
    
        )
    }
}

export default GameCard;